import { Injectable } from '@angular/core';
import { EstrategiasReportes, ServicioReportes } from '../core/servicio-reportes';
import { ReporteRegistrado, ResultadoReporte } from '../core/reporte';
import { ReportesApiService } from '../reportes-api.services';
import { FormatoReporteTgr, TGR_REPORTES_DATOS } from './tipos-reporte';
import { parsearDeudasVigentesTgr } from './reportes-parser';

function resultadoSimple<T>(data: T): ResultadoReporte<T> {
    return { data };
}


@Injectable({ providedIn: 'root' })
export class TgrReportesService extends ServicioReportes<'TGR', typeof TGR_REPORTES_DATOS> {
    constructor(api: ReportesApiService) {
        const estrategias = {
            tgr_deudas_vencidas: {
                consultar: ({ idcliente }) => api.obtenerDeudasVigentesTgr(idcliente),
                transformar: (dto) => resultadoSimple(parsearDeudasVigentesTgr(dto))
            },
            tgr_convenios_vigentes: {
                consultar: ({ idcliente}) => api.obtenerConveniosVigentes(idcliente),
                transformar: (dto) => resultadoSimple(dto)
            },
            tgr_din_pagados: {
                consultar: ({ idcliente }) => api.obtenerDinPagadosTgr(idcliente),
                transformar: (dto) => resultadoSimple(dto)
            },
            tgr_din_pendientes: {
                consultar: ({ idcliente }) => api.obtenerDinPendientesTgr(idcliente),
                transformar: (dto) => resultadoSimple(dto)
            }
        } satisfies EstrategiasReportes<typeof TGR_REPORTES_DATOS>;

        super(
            {
                codigo: 'TGR',
                nombre: 'Tesorería General',
                ruta: '/tgr-reportes',
                icono: 'pi pi-wallet',
                permiso: 'reportes.ver',
                actualizacionMasiva: true
            },
            TGR_REPORTES_DATOS,
            estrategias
        );
    }
}

export type ReporteTgr = ReporteRegistrado<FormatoReporteTgr>;
